<template>
  <div>
    <!-- <mheader></mheader> -->
       <div v-show="tableData.length>0" style="width:1300px;margin:0 auto;margin-top:100px;" id="v-content" :style="{minHeight:Height+'px'}">
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
              <p class="mt-2 mb-2">
                  <!-- <img src="../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                  <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      最近日期销售
                  </span>
                   <span class="float-right span_close mr-2" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                   </span>
                </p>
                <div class="mb-2 mt-2" style="display:flex;align-items:center;">
                     <span class="ml-5 mr-2">
                       截至日期:
                     </span>
                     <date @changeDate="changeDate2($event)"/>
                     <span class="ml-5 mr-2">
                      最近多少天:
                     </span>
                     <input type="text" class="input_form-control" v-model="LastTop">
                     <button class="ml-5 bg-primary button_zi  hei" @click="getClerkSettlementQuery()">查询</button>
                </div>
              <div>
                <table class="table table-striped table-hover sett"  ref="print">
                <thead>
                  <tr style="white-space:nowrap;">
                      <th class="text-center">日期</th>
                      <th class="text-center" style="color:red;">总销售</th>
                      <th class="text-center" style="color:blue;">零库销售</th>
                      <th class="text-center" style="color:green;"> 线上销售</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in tableData" :key="index" style="white-space:nowrap;">
                      <td class="text-center">
                        <div>
                          {{item.date}}
                        </div>
                        <div style='margin-top:20px;'>
                            {{item.lDate}}
                        </div>
                        </td>
                      <td class="text-center" style="color:red;">
                        <div>
                         {{item.totalAmount}}
                        </div>
                        <div style='margin-top:20px;'>
                         {{item.lTotalAmount}}
                        </div>
                        </td>
                      <td class="text-center" style="color:blue;">
                        <div>
                           {{item.retailAmount}}
                        </div>
                        <div style='margin-top:20px;'>
                            {{item.lRetailAmount}}
                        </div>
                      </td>
                      <td class="text-center" style="color:green;">
                        <div>
                         {{item.netAmount}}
                        </div>
                        <div style='margin-top:20px;'>
                            {{item.lNetAmount}}
                        </div>
                        </td>
                </tr>
                </tbody>
              </table>
              </div>      
<!--             
                                <div>
                                   <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                              </div> -->
                                     <p class="text-center">
                                        <!-- <img src="../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/> -->
                                    </p>
                     
            </div>
       </div>

            <div v-show="Pcount===0" style="width:1300px;margin:0 auto;" id="v-content" :style="{minHeight:Height+'px'}">
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
               <p class="mt-2 mb-2">
                  <!-- <img src="../../static/images/kucun_1.png" style="width:1.5rem;height:1.5rem;" class="mb-lg-1" alt=""/> -->
                  <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      最近日期销售
                  </span>
                   <span class="float-right span_close mr-2" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                   </span>
                </p>
                <div class="mb-2 mt-2" style="display:flex;align-items:center;">
                     <span class="ml-5 mr-2">
                       截至日期:
                     </span>
                     <date @changeDate="changeDate2($event)"/>
                     <span class="ml-5 mr-2">
                      最近多少天:
                     </span>
                     <input type="text">
                     <button class="ml-5 bg-primary button_zi  hei" @click="getClerkSettlementQuery()">查询</button>
                </div>
              
                               <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">
                                     <p class="text-center">
                                        <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                                    </p>
                     
            </div>
       </div>

    <!-- 表单内容 -->
            <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
            </div>
   
  </div>
</template>
<script>
  import Loading from '../../components/Loading.vue'
import vPagination from "../../components/Pagination.vue";
 import date from '../../components/Date.vue'
  export default {
    name: 'SaleQuery',
    data() {
      return {
         Height:0,
        searchData: [],//搜索返回的清单
        isLoading: false,
        tableData: [],
        Record: '',//总记录数
        Pcount: '',//总页数
        PageNo: 1, //当前页码
        totalNum:"",
        totalMoney:'',
        feeMoney:'',
        DateMoreThan:'',

            total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
            LastTop:10,
      }
    },
    components: {
      vPagination,
      Loading,
      date,

    },
    computed: {},
    filters: {
      getTrue:function(result) {
             if(result){
              
             return "是"
             }
             if(!result){
            
               return "否"
             }
             
        } ,
         formatUTC: function (utc_datetime) {
           return utc_datetime.replace(/T/ig,"  ").substring(0,20)
      },
   },
    methods: {
        //动态绑定时间
        changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.DateMoreThan=time;
        //   console.log(time)
        //   this.searchForm.DateMoreThan1=date;
      },
      //这里获取最近日期销售数据
      getClerkSettlementQuery: async function (PageIndex) {
        // this.isLoading=true;
        let reg=/(^[1-9]\d*$)/
        if(!reg.test(this.LastTop)){
            alert("查询天数必须为正整数！")
        }
        else{
            this.PageNo = PageIndex || this.PageNo
            const {data: res} = await this.$http.post('Dls/getFun', {
              action:'Saleneardataquery',
              obj: JSON.stringify({
                PageIndex,
                PageSize: 20,
                LastTop:this.LastTop,
                EndDate:this.DateMoreThan,
              })
            })
            // console.log(res)
            if (res.isok) {
              const obj = res.data
              this.tableData = obj.rows
              this.total = obj.pcount
              this.Pcount = obj.pcount
              this.Record = obj.record
              this.totalNum = obj.totalNum
              this.totalMoney =obj.totalMoney
              this.feeMoney = obj.feeMoney
           
            }
        }
      },

     pagechange:function(currentPage){
         if(this.searchData.length>0){
           this.Search(currentPage)
         }else{

           this.getClerkSettlementQuery(currentPage);
         }
     },
      //搜索功能
      // 打印
      start_print() {
        this.$print(this.$refs.print);//$refs的值要和html里的ref一致
      }

    },
     mounted(){
          //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 100;  
　　//监听浏览器窗口变化　
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created() {
      this.getClerkSettlementQuery();

    }
  }
</script>
<style scoped>
  .table-hover > tbody > tr:hover {
    background-color: #dee2e6 !important;
  }
  .money{
      color:red;
      font-weight: 500;
  }
  .record{
      color:green;
      font-weight: 500;
  }
  .sett{
        width:1300px;
        table-layout:fixed;
       
  }
  .sett-td {

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

   -moz-text-overflow: ellipsis; 

}
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
 .autocut:hover
 {
     overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .hei{
    height:1.5rem;
  }
  .input_form-control { 
/* // display: block;  */
width: 5%; 
height: 25px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/pages/manager/LatestSale.vue